import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatAppraiser,
  processAppraiserResponse,
} from './utils';

const APPRAISER_URL = `${API_CONFIG.API}/node/appraiser`;

export default {
  saveAppraiser(appraiser) {
    return base.http().post(`${APPRAISER_URL}`, formatAppraiser(appraiser));
  },
  updateAppraisers(appraiser) {
    return base.http().patch(`${APPRAISER_URL}/${appraiser.id}`, formatAppraiser(appraiser));
  },
  getAllAppraisers() {
    return base.http().get(`${APPRAISER_URL}`)
      .then(res => processAppraiserResponse(res));
  },
};



// WEBPACK FOOTER //
// ./src/features/appraiser/service.js